import React from "react";
import { profile } from "../../data/portfolio";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 py-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-4 text-xs font-mono-display uppercase tracking-widest text-white/40">
        <div>
          © {new Date().getFullYear()} · {profile.name}
        </div>
        <div className="flex gap-4">
          <a data-testid="footer-link-linkedin" href={profile.linkedin} target="_blank" rel="noreferrer" className="hv-underline">LinkedIn</a>
          <a data-testid="footer-link-email" href={`mailto:${profile.email}`} className="hv-underline">Email</a>
        </div>
        <div className="text-[color:var(--primary)]">Crafted with neon & caffeine.</div>
      </div>
    </footer>
  );
};

export default Footer;